import { FC, Props } from "./typings";
import {
  ButtonGroup,
  Grow,
  MenuItem,
  MenuList,
  Button as MUIButton,
  Paper,
  Popper,
} from "@mui/material";
import { Fragment, useEffect, useRef, useState } from "react";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ClickAwayListener from "@mui/material/ClickAwayListener";

const SplitButton: FC<Props> = ({
  text,
  options,
  onClick,
  id,
  recoverDefaultOption,
}) => {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef<HTMLDivElement>(null);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const handleClick = () => {
    onClick(options[selectedIndex]);
  };

  const handleMenuItemClick = (
    event: React.MouseEvent<HTMLLIElement, MouseEvent>,
    index: number
  ) => {
    event.preventDefault();
    event.stopPropagation();
    setSelectedIndex(index);
    setOpen(false);

    if (recoverDefaultOption) {
      window.localStorage.setItem(`splitButton-${id}`, index.toString());
    }

    onClick(options[index]);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: Event) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }

    setOpen(false);
  };

  useEffect(() => {
    if (recoverDefaultOption) {
      const saved = window.localStorage.getItem(`splitButton-${id}`);

      if (saved) {
        setSelectedIndex(Number(saved));
      }
    }
  }, []);

  // <MUIButton
  //   style={{ textTransform: "none", boxShadow: "none", borderRadius: "8px" }}
  //   className={`${className} ${styles.bn}`}
  //   onClick={(e) => {
  //     if (loading) return;
  //     if (disabled) {
  //       handleError();
  //       return;
  //     }
  //     e.preventDefault();
  //     e.stopPropagation();
  //     onClick();
  //   }}
  //   variant="contained"
  //   color={color}
  //   disabled={disabled}
  // >
  //   {loading ? <Loading withoutText /> : <>{element ? element : text}</>}
  // </MUIButton>

  return (
    <Fragment>
      <ButtonGroup
        variant="contained"
        ref={anchorRef}
        aria-label="Button group with a nested menu"
        disableElevation={true}
      >
        <MUIButton
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            handleClick();
          }}
          style={{
            textTransform: "none",
            boxShadow: "none",
            borderRadius: "8px 0 0 8px",
          }}
        >
          {text}
        </MUIButton>
        <MUIButton
          size="small"
          aria-controls={open ? "split-button-menu" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-label="select merge strategy"
          aria-haspopup="menu"
          onClick={handleToggle}
          style={{
            textTransform: "none",
            boxShadow: "none",
            borderRadius: "0 8px 8px 0",
          }}
        >
          <ArrowDropDownIcon />
        </MUIButton>
      </ButtonGroup>
      <Popper
        sx={{ zIndex: 1 }}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom" ? "center top" : "center bottom",
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu" autoFocusItem>
                  {options.map((option, index) => (
                    <MenuItem
                      key={option.Id}
                      selected={index === selectedIndex}
                      onClick={(event) => handleMenuItemClick(event, index)}
                    >
                      {option.Name}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </Fragment>
  );
};

export default SplitButton;
